import { useHistory, useLocation } from "react-router-dom";
import NavCommon from "../../components/@navHeader";
import * as S from "./styles";

const StandEspelho = () => {
  const history = useHistory();
  const location = useLocation();

  // Pega os parâmetros da query string
  const searchParams = new URLSearchParams(location.search);
  const standEspelhoUrl = searchParams.get("url");
  const produtoNome = searchParams.get("produtoNome");
  const produtoCodigo = searchParams.get("produtoCodigo");

  const breadcrumbs = [{ path: "/produtos", name: "Produtos" }];

  if (produtoNome && produtoCodigo) {
    breadcrumbs.push({
      path: `/produtos/${produtoCodigo}`,
      name: produtoNome,
    });
  }

  breadcrumbs.push({ path: "", name: "Stand Espelho" });

  return (
    <S.Container>
      <NavCommon
        breadcrumbs={breadcrumbs}
        onBack={() => history.goBack()}
        onChangeActionNew={() => {}}
      />
      {!standEspelhoUrl ? (
        <S.ErrorMessage>URL do Stand Espelho não encontrada.</S.ErrorMessage>
      ) : (
        <S.Card>
          <S.Header>
            <S.Title>Stand Espelho</S.Title>
          </S.Header>
          <S.IframeContainer>
            <iframe
              src={standEspelhoUrl}
              frameBorder="0"
              title="Stand Espelho"
              allow="fullscreen"
              allowFullScreen
              style={{
                border: "none",
                width: "100%",
                height: "100%",
              }}
            />
          </S.IframeContainer>
        </S.Card>
      )}
    </S.Container>
  );
};

export default StandEspelho;
